import carousel3DotsPagination from "./carousel3DotsPagination";
import { YTVidAutoPause } from "./helpers";

let tns;

function init() {
    const carousels = document.querySelectorAll(".carousel-chc");

    if (carousels.length > 0 && !carousels[0].classList.contains("carousel--editMode")) {
        import("tiny-slider/src/tiny-slider").then((module) => {
            tns = module.tns;
            carousels.forEach(createCarousel);
        });
    }
}

function createCarousel(carousel) {
    const carouselSlides = carousel.querySelector(".carousel__slides");
    if (!carouselSlides) return;

    const carouselWrap = carousel.querySelector(".carousel__wrap");
    const dir = carouselWrap?.dataset.dir || "ltr";

    const carouselControls = carousel.querySelector(".carousel__controls");
    const autoplayButton = carousel.querySelector(".carousel__autoplayBtn");

    const itemsPerSlide = carouselWrap.dataset.itemsperslide;
    const itemsPerSlideTablet = carouselWrap.dataset.itemsperslidetablet;
    const itemsPerSlideDesktop = carouselWrap.dataset.itemsperslidedesktop;

    const autoplay = carouselWrap.dataset.autoplay === "true";
    const autoHeight = carouselWrap.dataset.autoheight === "true";
    const controls = carouselWrap.dataset.controls === "true";
    const pagination = carouselWrap.dataset.pagination === "true";
    const loop = carouselWrap.dataset.loop === "true";
    const uuid = carouselWrap.dataset.uuid;

    const customPrevBtn = carousel.querySelector(".custom-prev-button");
    const customNextBtn = carousel.querySelector(".custom-next-button");

    const startIndex = carouselStartIndex(carousel);

    const tnsSettings = {
        container: carouselSlides,
        autoplay,
        autoHeight,
        controls,
        controlsContainer: carouselControls,
        nav: pagination,
        navPosition: "bottom",
        loop,
        startIndex,
        items: itemsPerSlide,
        autoplayResetOnVisibility: false,
        autoplayButtonOutput: autoplay,
        autoplayButton: autoplay ? autoplayButton : false,
        autoplayText: [
            "<span class='carousel__playBtn carousel__btn'>▶</span>",
            "<span class='carousel__pauseBtn carousel__btn'>❚❚</span>",
        ],
        arrowKeys: true,
        edgePadding: 25,
        gutter: 10,
        responsive: {
            768: {
                items: itemsPerSlideTablet,
                edgePadding: 0,
                gutter: 20,
            },
            1024: {
                items: itemsPerSlideDesktop,
            },
        },
        onInit() {
            if (autoplay) {
                setupAutoplayA11y(autoplayButton);
            }

            carouselWrap.querySelector(".tns-liveregion")?.remove();
            removeTabIndex(carouselWrap);

            const carouselNav = carouselWrap.querySelector(".tns-nav");
            if (carouselNav && carouselNav.style.display !== "none") {
                carouselNav.classList.add("mx-auto");
                carouselWrap.classList.add("carousel__wrap--hasPadding");

                carouselNav.setAttribute(
                    "aria-label",
                    carouselWrap.dataset.paginationlabel
                );

                translatePageBullet(carouselWrap, carouselNav);

                if (carouselControls) {
                    carouselControls.setAttribute(
                        "aria-label",
                        carouselWrap.dataset.controlslabel
                    );
                    carouselControls.after(carouselNav);
                }
            }
        },
    };

    // Custom prev / next buttons
    if (customPrevBtn && customNextBtn) {
        tnsSettings.prevButton = customPrevBtn;
        tnsSettings.nextButton = customNextBtn;
    }

    const tnsCarousel = tns(tnsSettings);

    tnsCarousel.events.on("transitionEnd", () => {
        translatePageBullet(
            carouselWrap,
            carouselWrap.querySelector(".tns-nav")
        );
        removeTabIndex(carouselWrap);
    });

    tnsCarousel.events.on("transitionStart", () => {
        if (autoHeight) {
            updateHeightOnImageLoad(carouselWrap, tnsCarousel);
        }

        YTVidAutoPause(
            carouselWrap.querySelectorAll(".carousel__slide")
        );
    });

    // RTL: only handle autoHeight now (no JS lazyload)
    if (dir === "rtl" && autoHeight) {
        const callback = () =>
            window.setTimeout(() => tnsCarousel.updateSliderHeight(), 200);

        updateHeightOnImageLoad(carouselWrap, tnsCarousel, callback);

        tnsCarousel.events.on("indexChanged", () => {
            updateHeightOnImageLoad(carouselWrap, tnsCarousel, callback);
        });
    }

    window.tnsCarousels = window.tnsCarousels || [];
    window.tnsCarousels.push({ uuid, carousel: tnsCarousel });

    carousel3DotsPagination.newPagination(carouselWrap, tnsCarousel);
}

/* ---------------- Helpers ---------------- */

function setupAutoplayA11y(button) {
    if (!button) return;

    const setText = (status) => {
        const hiddenText = button.querySelector(".tns-visually-hidden");
        if (!hiddenText) return;

        hiddenText.innerHTML =
            status === "start"
                ? button.dataset.starttext
                : button.dataset.stoptext;
    };

    setText("stop");

    button.addEventListener("click", function () {
        setText(this.dataset.action);
    });
}

function updateHeightOnImageLoad(carouselWrap, tnsCarousel, callback) {
    carouselWrap
        .querySelectorAll(".tns-slide-active img")
        .forEach((img) => {
            if (img.complete) {
                callback ? callback() : tnsCarousel.updateSliderHeight();
            } else {
                img.addEventListener(
                    "load",
                    () => {
                        callback
                            ? callback()
                            : tnsCarousel.updateSliderHeight();
                    },
                    { once: true }
                );
            }
        });
}

function removeTabIndex(carouselWrap) {
    carouselWrap.querySelectorAll("[tabindex]").forEach((el) => {
        el.removeAttribute("tabindex");
    });
}

function carouselStartIndex(carousel) {
    const carouselWrap = carousel.querySelector(".carousel__wrap");
    const dir = carouselWrap?.dataset.dir;

    let index = 0;

    if (dir === "rtl") {
        let slideLength = carousel.querySelectorAll(".carousel__slide").length;

        if (slideLength === 0) {
            slideLength = carousel.querySelectorAll(".anchorItem").length;
        }

        const loop = carouselWrap.dataset.loop === "true";

        if (loop) {
            const w = window.innerWidth;
            const itemsPerSlide =
                w >= 1024
                    ? carouselWrap.dataset.itemsperslidedesktop
                    : w >= 768
                    ? carouselWrap.dataset.itemsperslidetablet
                    : carouselWrap.dataset.itemsperslide;

            index = Math.max(slideLength - itemsPerSlide, 0);
        } else {
            index = slideLength - 1;
        }
    }

    return index;
}

function translatePageBullet(carouselWrap, carouselNav) {
    if (!carouselNav) return;

    const bulletLabel = carouselWrap.dataset.paginationbulletlabel;
    const activeBulletLabel =
        carouselWrap.dataset.paginationactivebulletlabel;

    carouselNav.querySelectorAll("button").forEach((bullet, index) => {
        let label = `${bulletLabel} ${index + 1}`;
        if (bullet.classList.contains("tns-nav-active")) {
            label += ` (${activeBulletLabel})`;
        }
        bullet.setAttribute("aria-label", label);
    });
}

export default { init };
